import { atom } from "jotai";

export const seccionesAtom = atom([]);